module.exports = __webpack_public_path__ + "img/sipretres.60d46306.gif";